export const smdProducts = [
  {
    title: { sv: "Smini – Minisändare", en: "Smini – Mini transmitter" },
    description: {
      sv: "Kompakt handsändare som finns i 40 MHz och 868 MHz med 1 eller 2 knappar.",
      en: "Compact hand transmitter available in 40 MHz and 868 MHz with 1 or 2 buttons.",
    },
    image: "/images/products/SMD/smini/1.png",
    gallery: [
      "/images/products/SMD/smini/1.png",
      "/images/products/SMD/smini/2.png",
      "/images/products/SMD/smini/3.png",
      "/images/products/SMD/smini/4.png",
    ],
    slug: "smini",
    category: "Sändare",
    pdfs: [
      {
        label: {
          sv: "Datablad – SMini 40 MHz",
          en: "Datasheet – SMini 40 MHz",
        },
        url: "/pdfs/smd/Handsandare/Mini/SMini40 LW40MS se.pdf",
      },
      {
        label: {
          sv: "Datablad – SMini 868 MHz",
          en: "Datasheet – SMini 868 MHz",
        },
        url: "/pdfs/smd/Handsandare/Mini/SMini868 se.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Två frekvensalternativ", en: "Two frequency options" },
        description: {
          sv: "Finns i 40 MHz och 868 MHz för enkel integration i både befintliga och nya radiostyrningssystem.",
          en: "Available in 40 MHz and 868 MHz for easy integration into both existing and new radio remote control systems.",
        },
      },
      {
        title: { sv: "Kompakt och ergonomisk", en: "Compact and ergonomic" },
        description: {
          sv: "Liten och lätt design som ligger bekvämt i handen eller fickan för daglig användning.",
          en: "Small and lightweight design that fits comfortably in the hand or pocket for daily use.",
        },
      },
      {
        title: { sv: "1 eller 2 knappar", en: "1 or 2 buttons" },
        description: {
          sv: "Välj mellan en eller två knappar beroende på hur många funktioner som ska styras.",
          en: "Choose between one or two buttons depending on how many functions need to be controlled.",
        },
      },
      {
        title: { sv: "Byggd för daglig användning", en: "Built for daily use" },
        description: {
          sv: "Robust konstruktion och tillförlitlig radiokommunikation för professionella och privata installationer.",
          en: "Robust construction and reliable radio communication for professional and private installations.",
        },
      },
    ],
  },
  {
    title: { sv: "Smidi – Midisändare", en: "Smidi – Midi transmitter" },
    description: {
      sv: "Robust handsändare för 433 MHz och 868 MHz med upp till sex knappar och hög skyddsklass.",
      en: "Robust hand transmitter for 433 MHz and 868 MHz with up to six buttons and high protection class.",
    },
    image: "/images/products/SMD/smidi/1.png",
    gallery: [
      "/images/products/SMD/smidi/1.png",
      "/images/products/SMD/smidi/2.png",
      "/images/products/SMD/smidi/3.png",
    ],
    slug: "smidi",
    category: "Sändare",
    pdfs: [
      {
        label: {
          sv: "Datablad – SMidi WP 433 MHz",
          en: "Datasheet – SMidi WP 433 MHz",
        },
        url: "/pdfs/smd/Handsandare/Midi/SMidiWP433 se.pdf",
      },
      {
        label: {
          sv: "Datablad – SMidi WP 868 MHz",
          en: "Datasheet – SMidi WP 868 MHz",
        },
        url: "/pdfs/smd/Handsandare/Midi/SMidiWP868 se.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Två frekvensalternativ", en: "Two frequency options" },
        description: {
          sv: "Finns i 433 MHz och 868 MHz för enkel integration i olika radiostyrningssystem.",
          en: "Available in 433 MHz and 868 MHz for easy integration into various radio remote control systems.",
        },
      },
      {
        title: { sv: "Upp till 6 knappar", en: "Up to 6 buttons" },
        description: {
          sv: "Kan levereras med mellan en och sex knappar för flexibel styrning av flera funktioner.",
          en: "Can be delivered with between one and six buttons for flexible control of multiple functions.",
        },
      },
      {
        title: {
          sv: "Byggd för tuffa miljöer",
          en: "Built for tough environments",
        },
        description: {
          sv: "Finns i utföranden med skyddsklass upp till IP67 för maximalt skydd mot damm och vatten.",
          en: "Available in versions with protection class up to IP67 for maximum protection against dust and water.",
        },
      },
      {
        title: {
          sv: "Ergonomisk och slitstark design",
          en: "Ergonomic and durable design",
        },
        description: {
          sv: "Greppvänlig konstruktion med skyddssarg som ger hög komfort och lång livslängd.",
          en: "Grip-friendly construction with a protective bumper that provides high comfort and long service life.",
        },
      },
    ],
  },
  {
    title: {
      sv: "SI – Industrihandsändare",
      en: "SI – Industrial hand transmitter",
    },
    description: {
      sv: "Professionell industrihandsändare för 40, 433, 868 och 915 MHz med omfattande konfigurationsmöjligheter.",
      en: "Professional industrial hand transmitter for 40, 433, 868 and 915 MHz with extensive configuration options.",
    },
    image: "/images/products/SMD/si-industrisandare/1.png",
    gallery: [
      "/images/products/SMD/si-industrisandare/1.png",
      "/images/products/SMD/si-industrisandare/2.png",
    ],
    slug: "si-industrisandare",
    category: "Sändare",
    pdfs: [
      {
        label: {
          sv: "Datablad – SI 40/868 MHz",
          en: "Datasheet – SI 40/868 MHz",
        },
        url: "/pdfs/smd/Handsandare/Industri/SI40_868 LWS40AM se.pdf",
      },
      {
        label: { sv: "Datablad – SI 433 MHz", en: "Datasheet – SI 433 MHz" },
        url: "/pdfs/smd/Handsandare/Industri/SI433 LWS433FM LWSV433FM se.pdf",
      },
      {
        label: { sv: "Datablad – SI 868 MHz", en: "Datasheet – SI 868 MHz" },
        url: "/pdfs/smd/Handsandare/Industri/SI868 SMD7000 se.pdf",
      },
      {
        label: {
          sv: "Datablad – SI WP 433 MHz",
          en: "Datasheet – SI WP 433 MHz",
        },
        url: "/pdfs/smd/Handsandare/Industri/SIWP433 se.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Fyra frekvensalternativ", en: "Four frequency options" },
        description: {
          sv: "Finns i 40 MHz, 433 MHz, 868 MHz och 915 MHz för både nya och befintliga system.",
          en: "Available in 40 MHz, 433 MHz, 868 MHz and 915 MHz for both new and existing systems.",
        },
      },
      {
        title: {
          sv: "Anpassningsbar efter dina behov",
          en: "Customizable to your needs",
        },
        description: {
          sv: "Kan levereras med 1–8 knappar samt tumhjulsomkopplare och Rocker Switch.",
          en: "Can be delivered with 1–8 buttons as well as thumbwheel switch and Rocker Switch.",
        },
      },
      {
        title: {
          sv: "Utvecklad för industrimiljöer",
          en: "Developed for industrial environments",
        },
        description: {
          sv: "Robust konstruktion med stötskydd och bältesclips för daglig användning i krävande miljöer.",
          en: "Robust construction with impact protection and belt clip for daily use in demanding environments.",
        },
      },
      {
        title: { sv: "Professionell styrning", en: "Professional control" },
        description: {
          sv: "Frontskylt med färgsymboler som standard och möjlighet till kundanpassad märkning.",
          en: "Front label with color symbols as standard and possibility for customized labeling.",
        },
      },
    ],
  },
  {
    title: { sv: "SF - Fordonssändare", en: "SF - Vehicle transmitter" },
    description: {
      sv: "Robust fordonssändare för fast montering, utvecklad för professionella styrsystem och mobila applikationer.",
      en: "Robust vehicle transmitter for fixed mounting, developed for professional control systems and mobile applications.",
    },
    image: "/images/products/SMD/fordonssandare/1.png",
    gallery: [
      "/images/products/SMD/fordonssandare/1.png",
      "/images/products/SMD/fordonssandare/2.png",
      "/images/products/SMD/fordonssandare/3.png",
      "/images/products/SMD/fordonssandare/4.png",
    ],
    slug: "fordonssandare",
    category: "Sändare",
    pdfs: [
      {
        label: {
          sv: "Datablad – Fordonssändare 40 MHz",
          en: "Datasheet – Vehicle transmitter 40 MHz",
        },
        url: "/pdfs/smd/Handsandare/Fordon/SF40 SMD700 se.pdf",
      },
      {
        label: {
          sv: "Datablad – Fordonssändare 433 MHz",
          en: "Datasheet – Vehicle transmitter 433 MHz",
        },
        url: "/pdfs/smd/Handsandare/Fordon/SF433 SMD700 se.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Tre frekvensalternativ", en: "Three frequency options" },
        description: {
          sv: "Finns i 40 MHz, 433 MHz och 868 MHz för enkel integration i olika radiostyrningssystem.",
          en: "Available in 40 MHz, 433 MHz and 868 MHz for easy integration into various radio remote control systems.",
        },
      },
      {
        title: { sv: "Fast montering", en: "Fixed mounting" },
        description: {
          sv: "Utvecklad för permanent installation i fordon, maskiner och andra mobila applikationer.",
          en: "Developed for permanent installation in vehicles, machines and other mobile applications.",
        },
      },
      {
        title: { sv: "Flexibel styrning", en: "Flexible control" },
        description: {
          sv: "Kan levereras med 1–3 knappar samt en eller två robusta valvred.",
          en: "Can be delivered with 1–3 buttons as well as one or two robust rotary switches.",
        },
      },
      {
        title: {
          sv: "Byggd för professionella applikationer",
          en: "Built for professional applications",
        },
        description: {
          sv: "Robust konstruktion för tillförlitlig styrning i krävande arbetsmiljöer.",
          en: "Robust construction for reliable control in demanding work environments.",
        },
      },
    ],
  },
  {
    title: {
      sv: "MV - Väggmonterad mottagare",
      en: "MV - Wall-mounted receiver",
    },
    description: {
      sv: "Flexibel väggmonterad mottagare med upp till fyra reläutgångar för säker och tillförlitlig radiostyrning.",
      en: "Flexible wall-mounted receiver with up to four relay outputs for safe and reliable radio remote control.",
    },
    image: "/images/products/SMD/wall-receiver/1.jpg",
    gallery: [
      "/images/products/SMD/wall-receiver/1.jpg",
      "/images/products/SMD/wall-receiver/2.png",
      "/images/products/SMD/wall-receiver/3.png",
    ],
    slug: "smd-wall-receiver",
    category: "Mottagare",
    pdfs: [
      {
        label: {
          sv: "Datablad – LW40EB MV868-433-40",
          en: "Datasheet – LW40EB MV868-433-40",
        },
        url: "/pdfs/smd/Mottagare/Vagg/LW40EB MV868-433-40.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Upp till fyra reläutgångar",
          en: "Up to four relay outputs",
        },
        description: {
          sv: "Utrustad med upp till fyra potentialfria reläutgångar som ger flexibel styrning och enkel integration i olika typer av installationer.",
          en: "Equipped with up to four potential-free relay outputs that provide flexible control and easy integration into various types of installations.",
        },
      },
      {
        title: { sv: "Tre programmeringslägen", en: "Three programming modes" },
        description: {
          sv: "Varje reläutgång kan programmeras individuellt som momentan, togglande eller hållande.",
          en: "Each relay output can be programmed individually as momentary, toggling or latching.",
        },
      },
      {
        title: {
          sv: "Stabil radiokommunikation",
          en: "Stable radio communication",
        },
        description: {
          sv: "Utvecklad för säker och tillförlitlig kommunikation med hög driftsäkerhet.",
          en: "Developed for safe and reliable communication with high operational reliability.",
        },
      },
      {
        title: { sv: "Enkel installation", en: "Easy installation" },
        description: {
          sv: "Kompakt kapsling, tydliga anslutningar och smidig montering för både nya och befintliga installationer.",
          en: "Compact housing, clear connections and easy mounting for both new and existing installations.",
        },
      },
    ],
  },
  {
    title: {
      sv: "MVDB - Väggmonterad mottagare Dual Band",
      en: "MVDB - Wall-mounted receiver Dual Band",
    },
    description: {
      sv: "Dual Band-mottagare med stöd för flera frekvensband och avancerad styrning för professionella installationer.",
      en: "Dual Band receiver with support for multiple frequency bands and advanced control for professional installations.",
    },
    image: "/images/products/SMD/wall-receiver-dual-band/1.png",
    gallery: [
      "/images/products/SMD/wall-receiver-dual-band/1.png",
      "/images/products/SMD/wall-receiver-dual-band/2.png",
    ],
    slug: "smd-wall-receiver-dual-band",
    category: "Mottagare",
    pdfs: [
      {
        label: {
          sv: "Datablad – LW40EB MV868-433-40 DB",
          en: "Datasheet – LW40EB MV868-433-40 DB",
        },
        url: "/pdfs/smd/Mottagare/Vagg DB/LW40EB MV868-433-40 DB.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Dual Band-teknik", en: "Dual Band technology" },
        description: {
          sv: "Stöd för flera frekvensband ger hög flexibilitet och gör mottagaren enkel att integrera i både nya och befintliga system.",
          en: "Support for multiple frequency bands provides high flexibility and makes the receiver easy to integrate into both new and existing systems.",
        },
      },
      {
        title: { sv: "Upp till 10 utgångar", en: "Up to 10 outputs" },
        description: {
          sv: "Kan konfigureras med upp till tio utgångar för styrning av flera funktioner från en och samma mottagare.",
          en: "Can be configured with up to ten outputs for controlling multiple functions from a single receiver.",
        },
      },
      {
        title: { sv: "Flexibel programmering", en: "Flexible programming" },
        description: {
          sv: "Utgångarna kan programmeras individuellt som momentan, togglande eller hållande.",
          en: "The outputs can be programmed individually as momentary, toggling or latching.",
        },
      },
      {
        title: {
          sv: "IO-stöd för lokal styrning",
          en: "IO support for local control",
        },
        description: {
          sv: "Kan utrustas med IO-kort för anslutning av fysiska knappar eller externa styrsignaler direkt till mottagaren.",
          en: "Can be equipped with IO cards for connecting physical buttons or external control signals directly to the receiver.",
        },
      },
    ],
  },
  {
    title: {
      sv: "MDIN - Mottagare för DIN-skena",
      en: "MDIN - DIN-rail receiver",
    },
    description: {
      sv: "Kompakt DIN-skenemottagare för styr- och automationssystem med flexibel konfigurering.",
      en: "Compact DIN-rail receiver for control and automation systems with flexible configuration.",
    },
    image: "/images/products/SMD/din-receiver/1.png",
    gallery: [
      "/images/products/SMD/din-receiver/1.png",
      "/images/products/SMD/din-receiver/2.png",
    ],
    slug: "smd-din-receiver",
    category: "Mottagare",
    pdfs: [
      {
        label: {
          sv: "Datablad – SMD700 MD868-433-40",
          en: "Datasheet – SMD700 MD868-433-40",
        },
        url: "/pdfs/smd/Mottagare/Din-Skena/SMD700 MD868-433-40.pdf",
      },
    ],
    features: [
      {
        title: { sv: "DIN-skenemontering", en: "DIN-rail mounting" },
        description: {
          sv: "Konstruerad för snabb och säker montering på standardiserad 35 mm DIN-skena.",
          en: "Designed for fast and secure mounting on a standardized 35 mm DIN rail.",
        },
      },
      {
        title: { sv: "Flexibel styrning", en: "Flexible control" },
        description: {
          sv: "Stöd för upp till tio utgångar och flera programmeringslägen gör mottagaren anpassningsbar.",
          en: "Support for up to ten outputs and multiple programming modes makes the receiver adaptable.",
        },
      },
      {
        title: { sv: "Tre programmeringslägen", en: "Three programming modes" },
        description: {
          sv: "Varje utgång kan programmeras individuellt som momentan, togglande eller hållande.",
          en: "Each output can be programmed individually as momentary, toggling or latching.",
        },
      },
      {
        title: {
          sv: "För professionella installationer",
          en: "For professional installations",
        },
        description: {
          sv: "Kompakt konstruktion med tydliga anslutningar gör mottagaren enkel att integrera i elcentraler och apparatskåp.",
          en: "Compact construction with clear connections makes the receiver easy to integrate into distribution boards and control cabinets.",
        },
      },
    ],
  },
  {
    title: {
      sv: "MF868 – Mottagare med 6 MOSFET-utgångar",
      en: "MF868 – Receiver with 6 MOSFET outputs",
    },
    description: {
      sv: "Fordonsanpassad mottagare med sex MOSFET-utgångar för krävande och tillförlitliga styrsystem.",
      en: "Vehicle-adapted receiver with six MOSFET outputs for demanding and reliable control systems.",
    },
    image: "/images/products/SMD/mf868/1.png",
    gallery: [
      "/images/products/SMD/mf868/1.png",
      "/images/products/SMD/mf868/2.png",
      "/images/products/SMD/mf868/3.png",
    ],
    slug: "mf868",
    category: "Mottagare",
    pdfs: [
      {
        label: { sv: "Datablad – LW MF868", en: "Datasheet – LW MF868" },
        url: "/pdfs/smd/Mottagare/Mosfet/LW MF868.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Optimerad för fordonsapplikationer",
          en: "Optimized for vehicle applications",
        },
        description: {
          sv: "Utvecklad för montering i fordon och mobila maskiner där tillförlitlig radiostyrning är avgörande.",
          en: "Developed for installation in vehicles and mobile machines where reliable radio remote control is essential.",
        },
      },
      {
        title: { sv: "Sex MOSFET-utgångar", en: "Six MOSFET outputs" },
        description: {
          sv: "Brytarlösa MOSFET-utgångar ger snabb, tyst och tillförlitlig styrning med lång livslängd.",
          en: "Switchless MOSFET outputs provide fast, quiet and reliable control with long service life.",
        },
      },
      {
        title: { sv: "Flexibel programmering", en: "Flexible programming" },
        description: {
          sv: "Utgångarna kan programmeras individuellt som momentan, togglande eller hållande.",
          en: "The outputs can be programmed individually as momentary, toggling or latching.",
        },
      },
      {
        title: {
          sv: "Anpassningsbar efter dina behov",
          en: "Customizable to your needs",
        },
        description: {
          sv: "Levereras färdigprogrammerad och kan kundanpassas med specialutvecklad mjukvara vid behov.",
          en: "Delivered pre-programmed and can be customized with specially developed software if needed.",
        },
      },
    ],
  },
];
